// @ts-nocheck
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import AmericanExpress from "@store/Library/Components/Toolkit/Icons/AmericanExpress";
import Discover from "@store/Library/Components/Toolkit/Icons/Discover";
import Mastercard from "@store/Library/Components/Toolkit/Icons/Mastercard";
import Visa from "@store/Library/Components/Toolkit/Icons/Visa";
import { savedPaymentsProps } from "@store/Themes/common/props/savedPayments";
import React, { FC, useMemo } from "react";

export interface SavedPaymentsCardIconProps {
    cardType: string;
}

export interface SavedPaymentsCardIconStyles {
    icon?: IconPresentationProps;
}

export const savedPaymentsCardIconStyles: SavedPaymentsCardIconStyles = {
    icon: savedPaymentsProps.card?.icon,
};

const styles = savedPaymentsCardIconStyles;

const SavedPaymentsCardIcon: FC<SavedPaymentsCardIconProps> = ({ cardType }) => {
    const iconSrc = useMemo(() => {
        switch (cardType.toLowerCase()) {
            case "american express":
                return AmericanExpress;
            case "discover":
                return Discover;
            case "mastercard":
                return Mastercard;
            case "visa":
                return Visa;
        }
    }, [cardType]);

    return iconSrc ? <Icon src={iconSrc} {...styles.icon} /> : null;
};

export default SavedPaymentsCardIcon;
